import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function MassageTherapyCourseSummary() {
  const courseHighlights = ["Anatomía y Fisiología Aplicada", "Técnicas de Masaje Descontracturante", "Drenaje Linfático Manual", "Protocolos de Relajación Profunda"];
  return <section id="resumen-del-curso-de-masoterapia" className="bg-background relative w-full overflow-hidden">
      {}
      <div className="relative w-full min-h-[85vh] bg-foreground py-20 lg:py-32 flex items-center">
        
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-20 pointer-events-none"></div>
        
        {}
        <div className="absolute inset-0 opacity-[0.03] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/noise_texture_generic.png)] mix-blend-overlay pointer-events-none"></div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">

            {}
            <div className="lg:col-span-7 relative flex flex-col items-start z-20">
              
              {}
              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-sans font-extrabold uppercase tracking-tight text-background mb-10 [text-shadow:0_0_25px_var(--color-secondary)]">
                Masoterapia
              </h1>

              <div className="relative w-full max-w-2xl">
                {}
                <div className="absolute -top-4 -left-2 md:-left-6 z-30">
                  <Badge className="bg-secondary text-secondary-foreground hover:bg-secondary/90 text-sm md:text-base px-5 py-1.5 shadow-[0_0_20px_var(--color-secondary)] border-none font-bold tracking-wide uppercase">
                    Inscripciones Abiertas
                  </Badge>
                </div>

                {}
                <Card className="bg-foreground/70 backdrop-blur-[12px] border-border/10 shadow-2xl relative overflow-hidden rounded-3xl">
                  {}
                  <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent pointer-events-none"></div>
                  
                  <CardContent className="p-8 md:p-10 relative z-10 flex flex-col gap-8">
                    <p className="text-lg md:text-xl text-muted font-sans leading-relaxed">
                      Domina el arte del bienestar físico. Nuestro programa integral te sumerge en las técnicas más avanzadas de masaje terapéutico, preparándote para transformar la salud y calidad de vida de tus futuros pacientes.
                    </p>

                    <ul className="flex flex-col gap-4">
                      {courseHighlights.map((item, i) => <li key={i} data-index={i} className="flex items-center gap-4 text-muted">
                          <div className="bg-primary/20 p-1 rounded-full">
                            <CheckCircle2 className="w-5 h-5 text-primary shrink-0" />
                          </div>
                          <span className="font-medium text-base md:text-lg">{item}</span>
                        </li>)}
                    </ul>

                    <div className="flex flex-col sm:flex-row gap-4 pt-4">
                      <Link to="https://wa.me/59896344395">
                        <Button size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 group h-14 px-8 text-lg rounded-xl shadow-[0_0_20px_var(--color-primary)]">
                          Inscribirse por WhatsApp
                          <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1.5 transition-transform" />
                        </Button>
                      </Link>
                      <Link to="YOUR_MERCADOPAGO_URL">
                        <Button size="lg" variant="secondary" className="w-full sm:w-auto h-14 px-8 text-lg rounded-xl shadow-[0_0_20px_var(--color-secondary)] group">
                          Pagar Inscripción
                          <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1.5 transition-transform" />
                        </Button>
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>

            {}
            <div className="lg:col-span-5 relative w-full aspect-[4/5] lg:aspect-auto lg:h-[700px] rounded-3xl overflow-hidden shadow-2xl group mt-8 lg:mt-0">
              
              {}
              <div className="absolute inset-0 bg-primary/30 mix-blend-color z-10 transition-opacity duration-700 group-hover:opacity-10"></div>
              
              {}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_40%,var(--color-foreground)_120%)] z-20 pointer-events-none"></div>

              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/massage_therapy_action_shot.png" alt="Sesión profesional de masoterapia en acción" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
            </div>

          </div>
        </div>
      </div>
    </section>;
}